import { useAppBridge } from "@shopify/app-bridge-react";

/**
 * Module-level singleton for the App Bridge instance — set by useAuthFetch
 * the first time it runs in any component. Allows authFetch() to be called
 * from non-React code after at least one component has mounted.
 */
let shopifyInstance = null;

/**
 * React hook returning a fetch wrapper that adds Authorization: Bearer <token>
 * with App Bridge's session token (JWT). Token is fetched per-request.
 */
export function useAuthFetch() {
  const shopify = useAppBridge();
  if (shopify && !shopifyInstance) shopifyInstance = shopify;
  return (url, options = {}) => authFetchWith(shopify, url, options);
}

/**
 * Module-level fetcher — usable from non-component code if a component
 * has already called useAuthFetch (which sets the singleton).
 */
export function authFetch(input, init) {
  if (!shopifyInstance) {
    throw new Error("authFetch called before App Bridge initialized — ensure a component has called useAuthFetch first");
  }
  return authFetchWith(shopifyInstance, input, init);
}

async function authFetchWith(shopify, url, options = {}) {
  const token = await shopify.idToken();
  const headers = new Headers(options.headers || {});
  headers.set("Authorization", `Bearer ${token}`);
  return fetch(url, { ...options, headers });
}
